module.exports = __webpack_public_path__ + "img/27.951255ec.png";